module.exports = __webpack_public_path__ + "static/media/blog-5.c2816f17.jpg";